<template>
  <div class="formContent">
    <div class="form">
      <ul class="header"></ul>
      <div class="prompt">
        <span style="display:none"
          >*(目前开放上半年课程，5月6日开启下半年课程报名通道)</span
        >
      </div>
    </div>
    <div class="content">
      <div class="section-title" v-if="array1.length > 0">{{ array1[0].activeName }}</div>
      <table class="tableTitle">
        <tr class="titleTr">
          <th>时间</th>
          <th>地点</th>
          <th>剩余名额</th>
          <th>报名截止时间</th>
        </tr>
        <tr
          class="titleTd "
          :class="index % 2 ? 'titleTd1' : 'titleTd'"
          v-for="(item, index) in array1"
          :key="item.id"
          @click="registrationStatus(item)"
        >
          <td class="item1">{{ item.activeDate }}</td>
          <td class="item2">{{ item.activeAddr }}</td>
          <td class="item3" v-if="item.activeUserResidue > 0">有</td>
          <td class="item3" v-else>无</td>
          <td class="item4">{{ item.endDate }}</td>
          <td
            class="item5"
            v-if="timestamp > item.starTime && item.endTime > timestamp"
          >
            报名
          </td>
          <td class="item6" v-if="timestamp < item.starTime">未开始</td>
          <td class="item6" v-if="timestamp > item.endTime">已结束</td>
        </tr>
      </table>
    </div>
    <div class="content">
      <div class="section-title" v-if="array2.length > 0">{{ array2[0].activeName }}</div>
      <table class="tableTitle">
        <tr class="titleTr">
          <th>时间</th>
          <th>地点</th>
          <th>剩余名额</th>
          <th>报名截止时间</th>
        </tr>
        <tr
          class="titleTd "
          :class="index % 2 ? 'titleTd1' : 'titleTd'"
          v-for="(item, index) in array2"
          :key="item.id"
          @click="registrationStatus(item)"
        >
          <td class="item1">{{ item.activeDate }}</td>
          <td class="item2">{{ item.activeAddr }}</td>
          <td class="item3" v-if="item.activeUserResidue > 0">有</td>
          <td class="item3" v-else>无</td>
          <td class="item4">{{ item.endDate }}</td>
          <td
            class="item5"
            v-if="timestamp > item.starTime && item.endTime > timestamp"
          >
            报名
          </td>
          <td class="item6" v-if="timestamp < item.starTime">未开始</td>
          <td class="item6" v-if="timestamp > item.endTime">已结束</td>
        </tr>
      </table>
    </div>
    <div class="content">
      <div class="section-title" v-if="array3.length > 0">{{ array3[0].activeName }}</div>
      <table class="tableTitle">
        <tr class="titleTr">
          <th>时间</th>
          <th>地点</th>
          <th>剩余名额</th>
          <th>报名截止时间</th>
        </tr>
        <tr
          class="titleTd "
          :class="index % 2 ? 'titleTd1' : 'titleTd'"
          v-for="(item, index) in array3"
          :key="item.id"
          @click="registrationStatus(item)"
        >
          <td class="item1">{{ item.activeDate }}</td>
          <td class="item2">{{ item.activeAddr }}</td>
          <td class="item3" v-if="item.activeUserResidue > 0">有</td>
          <td class="item3" v-else>无</td>
          <td class="item4">{{ item.endDate }}</td>
          <td
            class="item5"
            v-if="timestamp > item.starTime && item.endTime > timestamp"
          >
            报名
          </td>
          <td class="item6" v-if="timestamp < item.starTime">未开始</td>
          <td class="item6" v-if="timestamp > item.endTime">已结束</td>
        </tr>
      </table>
    </div>
    <div class="content">
      <div class="section-title" v-if="array4.length > 0">{{ array4[0].activeName }}</div>
      <table class="tableTitle">
        <tr class="titleTr">
          <th>时间</th>
          <th>地点</th>
          <th>剩余名额</th>
          <th>报名截止时间</th>
        </tr>
        <tr
          class="titleTd "
          :class="index % 2 ? 'titleTd1' : 'titleTd'"
          v-for="(item, index) in array4"
          :key="item.id"
          @click="registrationStatus(item)"
        >
          <td class="item1">{{ item.activeDate }}</td>
          <td class="item2">{{ item.activeAddr }}</td>
          <td class="item3" v-if="item.activeUserResidue > 0">有</td>
          <td class="item3" v-else>无</td>
          <td class="item4">{{ item.endDate }}</td>
          <!-- 当前时间在活动开始时间和结束时间之间时，显示“报名” -->
          <td
            class="item5"
            v-if="timestamp > item.starTime && timestamp < item.endTime"
          >
            报名
          </td>
          <!-- 当前时间早于活动开始时间时，显示“未开始” -->
          <td class="item6" v-else-if="timestamp < item.starTime">未开始</td>
          <!-- 当前时间晚于活动结束时间时，显示“已结束” -->
          <td class="item6" v-else-if="timestamp > item.endTime">已结束</td>
        </tr>
      </table>
    </div>
     <div class="content">
      <div class="section-title" v-if="array5.length > 0">{{ array5[0].activeName }}</div>
      <table class="tableTitle">
        <tr class="titleTr">
          <th>时间</th>
          <th>地点</th>
          <th>剩余名额</th>
          <th>报名截止时间</th>
        </tr>
        <tr
          class="titleTd "
          :class="index % 2 ? 'titleTd1' : 'titleTd'"
          v-for="(item, index) in array5"
          :key="item.id"
          @click="registrationStatus(item)"
        >
          <td class="item1">{{ item.activeDate }}</td>
          <td class="item2">{{ item.activeAddr }}</td>
          <td class="item3" v-if="item.activeUserResidue > 0">有</td>
          <td class="item3" v-else>无</td>
          <td class="item4">{{ item.endDate }}</td>
          <!-- 当前时间在活动开始时间和结束时间之间时，显示“报名” -->
          <td
            class="item5"
            v-if="timestamp > item.starTime && timestamp < item.endTime"
          >
            报名
          </td>
          <!-- 当前时间早于活动开始时间时，显示“未开始” -->
          <td class="item6" v-else-if="timestamp < item.starTime">未开始</td>
          <!-- 当前时间晚于活动结束时间时，显示“已结束” -->
          <td class="item6" v-else-if="timestamp > item.endTime">已结束</td>
        </tr>
      </table>
    </div>
    <div class="buttom"></div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import { QueryActives } from '../api/forms'
export default {
  data () {
    return {
      openId: this.$cookies.get('openId') || '',
      meetingList: [],
      // 创建四个空数组
      array1: [],
      array2: [],
      array3: [],
      array4: [],
      array5: [],
      timestamp: new Date().getTime()
    }
  },
  methods: {
    getQueryActives () {
      QueryActives().then((res) => {
        // 遍历原始数据对象
        for (let key in res.data) {
          if (key === '1') {
            this.array1 = res.data[key]
          } else if (key === '2') {
            this.array2 = res.data[key]
          } else if (key === '3') {
            this.array3 = res.data[key]
          } else if (key === '4') {
            this.array4 = res.data[key]
          } else if (key === '5') {
            this.array5 = res.data[key]
          }
        }
      })
    },
    registrationStatus (item) {
      // 按钮变成一行可点击
      let timestamp = this.timestamp
      // 可报名
      if (timestamp > item.starTime && item.endTime > timestamp) {
        this.onApplication(item)
      } else if (timestamp < item.starTime) {
        // 未开始
        this.unopened()
      } else if (timestamp > item.endTime) {
        // 已结束
        this.endTime()
      }
    },
    onApplication (item) {
      // 如果剩余名额为0
      // if (item.activeUserResidue == 0) {
      //   Dialog.alert({
      //     message: "剩余名额已不足，无法报名",
      //   }).then(() => {
      //     // on close
      //   });
      // } else {
      this.$router.push({
        path: '/form',
        query: {
          openId: this.openId,
          id: item.id
        }
      })
      // }
    },

    // 未开启
    unopened () {
      Dialog.alert({
        message: '课程报名未开放'
      }).then(() => {
        // on close
      })
    },

    // 已结束
    endTime () {
      Dialog.alert({
        message: '课程已结束'
      }).then(() => {
        // on close
      })
    }
  },
  mounted () {
    this.getQueryActives()
  }
}
</script>
<style lang="scss" scoped>
.formContent {
  background-repeat: repeat;
  background-size: 100% 100%;
  height: 100vh;
  overflow-y: auto;

  .form {
    // min-height: 100vh;
    background: url("../assets/stateTitle.png") no-repeat;
    background-size: 100% auto;
    height: 180px;

    .header {
      text-align: center;
      position: relative;
      padding-top: 36%;
      letter-spacing: 2px;
    }

    .prompt {
      font-size: 11px;
      padding: 0 20px;
      color: #e81a26;
    }
  }

  .content {
      padding: 20px 20px 10px 20px;
      margin: 0 auto;

      .section-title {
        font-size: 16px;
        font-weight: bold;
        color: #757575;
        margin-bottom: 10px;
        text-align: left;
        letter-spacing: 2px;
        padding-left: 15px;
        position: relative;
      }

      .section-title::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 16px;
        background-color: #e81a26;
        border-radius: 2px;
      }

      img {
        width: 60%;
      }

    .tableTitle {
      margin-top: 10px;
      width: 100%;

      .titleTr {
        white-space: nowrap;
        /* 防止文字换行 */
        font-size: 12px;
        display: flex;
        justify-content: space-evenly;

        th {
          background-color: #e81a26;
          color: #fff;
          border-radius: 10px;
          padding: 3px 10px;
          font-weight: 400;
        }
      }

      .titleTd {
        display: flex;
        align-items: center;
        font-size: 11px;
        background-color: #fff;
        margin: 10px 0;

        td {
          margin-right: 5px;
          padding: 7px 0;
        }

        .item1 {
          width: 22%;
          white-space: nowrap;
        }

        .item2 {
          width: 20%;
          margin-left: 20px;
          white-space: nowrap;
        }

        .item3 {
          width: 18%;
          white-space: nowrap;
        }

        .item4 {
          white-space: nowrap;
          width: 15%;
        }

        .item5 {
          white-space: nowrap;
          color: red;
          font-weight: 800;
        }

        .item6 {
          white-space: nowrap;
          color: #706c6c;
          font-weight: 800;
        }
      }

      .titleTd1 {
        display: flex;
        align-items: center;
        font-size: 11px;
        background-color: #fafafa;
        margin: 10px 0;

        td {
          margin-right: 5px;
          padding: 7px 0;
        }

        .item1 {
          width: 22%;
          white-space: nowrap;
        }

        .item2 {
          width: 20%;
          margin-left: 20px;
          white-space: nowrap;
        }

        .item3 {
          width: 18%;
          white-space: nowrap;
        }

        .item4 {
          width: 15%;
          white-space: nowrap;
        }

        .item5 {
          white-space: nowrap;
          color: red;
          font-weight: 800;
        }
      }
    }
  }

  .buttom {
    background: url("../assets/bottom.png") no-repeat;
    background-size: 100% auto;
    height: 150px;
  }
}
</style>
